/**
 * @author silence
 * @desc:个人中心接口
 * */
// 带fp的都要token
import request from '@/utils/ajax';

export function queryLoginConfig(data) {//入金账号信息
	return request({
		url: '/crm/reception/queryLoginConfig',
		method: 'get',
        params:data,
        addToken:true,
	});
}

export function updateLoginConfig(data) {//入金账号信息
  return request({
    url: '/crm/reception/updateLoginConfig',
    method: 'put',
    data:data,
    addToken:true,
  });
}
